export const QA_INIT = 'QA_INIT';
export const QA_DRAW_MODE = 'QA_DRAW_MODE';
export const QA_GOTO_ISSUE = 'QA_GOTO_ISSUE';
export const QA_HOVER_ISSUE = 'QA_HOVER_ISSUE';
export const QA_ISSUES_SYNC = 'QA_ISSUES_SYNC';
export const QA_CAPTURE_AFTER = 'QA_CAPTURE_AFTER';

export const CONTENT_READY = 'CONTENT_READY';
export const QA_ISSUE_DRAFTED = 'QA_ISSUE_DRAFTED';
export const QA_ISSUE_CLONE_REQUESTED = 'QA_ISSUE_CLONE_REQUESTED';
export const QA_ISSUE_RESOLVED = 'QA_ISSUE_RESOLVED';
export const QA_PROGRESS = 'QA_PROGRESS';
export const QA_CAMERA_CHANGED = 'QA_CAMERA_CHANGED';
export const QA_AFTER_CAPTURED = 'QA_AFTER_CAPTURED';
export const QA_VARIANTS = 'QA_VARIANTS';
export const QA_OPEN_SCREENSHOTS = 'QA_OPEN_SCREENSHOTS';
export const QA_SET_STAGE = 'QA_SET_STAGE';
export const QA_STAGE_CHANGED = 'QA_STAGE_CHANGED';
// Виджет сообщает, открыта ли его полноэкранная разметка: пока она открыта,
// в CRM нечего дублировать рядом — исходник уже виден в сравнении.
export const QA_ANNOTATOR_STATE = 'QA_ANNOTATOR_STATE';

export const QaMode = {
  Review: 'review',
  Fix: 'fix',
};

export const QaResolution = {
  Fixed: 'fixed',
  CouldntFix: 'couldnt_fix',
};

export const QA_FULLSCREEN = 'QA_FULLSCREEN';
export const QA_GOTO_ROOM = 'QA_GOTO_ROOM';
